import styled from "styled-components"

import { useGetUser } from "src/data/user/hooks/useGetUser"
import { usePostRequestUserVerificationCode } from "src/data/user/queries/userQueries"
import { useTimer } from "src/hooks/useTimer"
import { useTranslate } from "src/i18n/useTranslate"
import WarningIcon from "src/ui/icons/warning.svg"
import { MBanner, MBannerProps } from "src/ui/MBanner/MBanner"

export function VerifyEmailBanner() {
  const { t, langKeys } = useTranslate()
  const user = useGetUser()
  const postRequestUserVerificationCode = usePostRequestUserVerificationCode()

  const { timeLeft, startTimer, isTimerRunning } = useTimer()

  function handleClickResendVerificationEmail() {
    postRequestUserVerificationCode.mutate(
      { path: { user_id: user.user_id } },
      {
        onSuccess: () => {
          // 60 seconds cooldown timer
          startTimer(60, { onExpire: postRequestUserVerificationCode.reset })
        },
      }
    )
  }

  const buttons: MBannerProps["buttons"] = [
    {
      label:
        t(langKeys.resend_email) + (isTimerRunning ? ` (${timeLeft})` : ""),
      onClick: handleClickResendVerificationEmail,
      buttonProps: {
        variant: "subtle",
        loading: postRequestUserVerificationCode.isLoading,
        disabled: isTimerRunning,
      },
    },
  ]

  if (postRequestUserVerificationCode.isSuccess) {
    return (
      <MBanner type="good" buttons={buttons}>
        {t(langKeys.verify_email_resent)}
      </MBanner>
    )
  }

  return (
    <MBanner
      type="warning"
      icon={<WarningIcon width={24} height={24} />}
      title={t(langKeys.verify_email_banner_title)}
      buttons={buttons}
    >
      <Content>
        <p>{t(langKeys.verify_email_sent, { email_address: user.email })}</p>
        <p>{t(langKeys.verify_email_check_spam)}</p>
      </Content>
    </MBanner>
  )
}

const Content = styled.div`
  p:first-child {
    margin-top: 0;
  }
  p:last-child {
    margin-bottom: 0;
  }
`
